import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Logo from '../images/logo.png';
import { Collapse } from 'reactstrap';

class Header extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState(state => ({ collapse: !state.collapse }));
  }
  render() {
    return (
      <header>
        <nav className='navbar navbar-expand-lg navbar-light'>
          <div className='container'>
            <Link className='navbar-brand' to='/'>
              <img
                src={Logo}
                className='pt-4 pb-2'
                alt={'Sturminster UK'}
                style={{ width: 'auto', height: 'auto' }}
              />
            </Link>
            <button
              className='navbar-toggler'
              type='button'
              onClick={this.toggle}
            >
              <span className='navbar-toggler-icon' />
            </button>
            <Collapse isOpen={this.state.collapse} className='navbar-collapse'>
              <ul className='navbar-nav ml-auto'>
                <li className='nav-item px-2'>
                  <Link className='nav-link' to='/'>
                    Home
                  </Link>
                </li>
                <li className='nav-item px-2'>
                  <Link className='nav-link' to='/about'>
                    About Us
                  </Link>
                </li>
                <li className='nav-item px-2'>
                  <Link className='nav-link' to='/services'>
                    Services
                  </Link>
                </li>
                {/* <li className="nav-item px-2">
                  <Link className="nav-link" to="/projects">
                    Projects
                  </Link>
                </li> */}
                <li className='nav-item px-2'>
                  <Link className='nav-link' to='/retail'>
                    Retail
                  </Link>
                </li>
                <li className='nav-item px-2'>
                  <Link className='nav-link' to='/leisure'>
                    Leisure
                  </Link>
                </li>
                <li className='nav-item px-2'>
                  <Link className='nav-link' to='/recruitment'>
                    Careers
                  </Link>
                </li>
                <li className='nav-item px-2'>
                  <Link className='nav-link' to='/contact'>
                    Contact
                  </Link>
                </li>
              </ul>
            </Collapse>
          </div>
        </nav>
        <hr />
      </header>
    );
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default Header;
